module.exports = __webpack_public_path__ + "static/media/close-set.6eb8ab84.svg";